export const ACCEPT_ONLY_IMAGES = 'image/*';

export const ACCEPT_ONLY_PDFS = 'application/pdf';

export const ACCEPT_ONLY_EXCELS =
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel';
